/**
 * Registers the service worker (production only). The SW lives in /public so it
 * is served from the site root with the right scope. Failures are non-fatal —
 * the app works without it.
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Ignore — SW is a progressive enhancement.
    });
  });
}
